export var BackgroundStyle = {
  warning: 'warning.main',
  critical: 'critical.main',
  success: 'success.main',
  neutral: 'neutral.black',
  brand: 'brand.main',
  informative: 'info.main'
};
//# sourceMappingURL=Counter.theme.utils.js.map